import { useMemo } from 'react'
import { generatePath, useRouteMatch } from 'react-router'
import { useFlags } from 'launchdarkly-react-client-sdk'

import ButtonWithTooltip from 'common/components/ButtonWithTooltip'
import {
  hideLeftPanel,
  selectLeftPanelVisibility,
  showLeftPanel,
} from 'common/components/leftPanel/store/leftPanelSlice'
import SubNavBar, { SubNavItem } from 'common/components/navigation/subNavBar'
import { useAppDispatch, useAppSelector } from 'common/hooks/redux'
import { SidebarLeftMenu as SidebarLeftMenuIcon } from 'common/icons'

import { DASHBOARD_NAV_ITEMS, PATH } from '../interfaces'

const DashboardHeader = () => {
  const accountId = useAppSelector((state) => state.authStates.accountId)
  const dispatch = useAppDispatch()
  const flags = useFlags()
  const isDashboardPathMatch = useRouteMatch(PATH.Dashboard)
  const leftPanelVisibility = useAppSelector(selectLeftPanelVisibility)

  const filteredNavItems = useMemo(() => {
    return DASHBOARD_NAV_ITEMS.filter(({ key }) => {
      switch (key) {
        case 'dashboard':
          return true
        case 'data-search':
          return flags.showReportingV1 && flags.showDataSearch
        case 'jaqi':
          return flags.showReportingV1 && flags.showJaqi
        default:
          return false
      }
    })
  }, [flags.showReportingV1, flags.showDataSearch, flags.showJaqi])

  return (
    <SubNavBar
      preTitle={
        isDashboardPathMatch &&
        flags.showSavedReports && (
          <ButtonWithTooltip
            tooltip
            tooltipText={
              leftPanelVisibility === 'hidden' || leftPanelVisibility === 'auto'
                ? 'Show panel'
                : 'Hide panel'
            }
            prefixIcon={<SidebarLeftMenuIcon isDefaultColor={false} size={5} />}
            onClick={() => {
              leftPanelVisibility === 'hidden'
                ? dispatch(showLeftPanel())
                : dispatch(hideLeftPanel())
            }}
          />
        )
      }
      title={isDashboardPathMatch && <span>Reports</span>}
    >
      {filteredNavItems.map(({ key, title, path }) => (
        <SubNavItem
          key={key}
          title={title}
          to={generatePath(path, { accountId })}
        />
      ))}
    </SubNavBar>
  )
}

export default DashboardHeader
